import { render, staticRenderFns } from "./WalletPasswordModal.vue?vue&type=template&id=6700a6da&scoped=true&"
import script from "./WalletPasswordModal.vue?vue&type=script&lang=js&"
export * from "./WalletPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./WalletPasswordModal.vue?vue&type=style&index=0&id=6700a6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700a6da",
  null
  
)

export default component.exports